type FormattedDateProps = {
  dt: string;
  label: string;
};

const FormattedDate = ({ dt, label }: FormattedDateProps) => {
  return (
    <>
      {label}{' '}
      <time dateTime={new Date(dt).toISOString()}>
        {new Date(dt).toLocaleDateString(undefined, {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })}
      </time>
    </>
  );
};

export default FormattedDate;
